module.exports = __webpack_public_path__ + "static/media/rogitama-360-preview.02ae60f9.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/360photos/rogitama-360-preview.JPG
// module id = 1155
// module chunks = 0